import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditLoanFeature = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [featureText, setFeatureText] = useState("");

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchFeatureDetails = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getSingleLoanFeatures/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const feature = res.data.feature;
      setSelectedLoanId(feature.loan_id);
      setFeatureText(feature.features);
    } catch (error) {
      console.error("Error fetching feature details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedLoanId || !featureText.trim()) {
      alert("Loan and feature are required");
      return;
    }

    try {
      await axios.put(
        `${COMMON_API}/loan/editLoanFeatures/${id}`,
        { loan_id: selectedLoanId, features: featureText },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate(-1);
    } catch (error) {
      console.error("Error updating feature:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
    fetchFeatureDetails();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Edit Loan Feature</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              value={selectedLoanId}
              onChange={(e) => setSelectedLoanId(e.target.value)}
              required
            >
              <option value="">-- Select Loan --</option>
              {loans.map((loan) => (
                <option key={loan.id} value={loan.id}>
                  {loan.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">Feature Description</label>
            <textarea
              rows="4"
              value={featureText}
              onChange={(e) => setFeatureText(e.target.value)}
              placeholder="Edit feature description..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            Update Feature
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanFeature;
